import React, { useState } from 'react'
import { Button, Form, Modal } from 'antd'
import MaskedInput from 'antd-mask-input'

interface ISignInMFADialog {
	visible: boolean
	onFinish: (code: string) => Promise<void>
}

interface IFormValues {
	code: string
}

export function SignInMFADialog({ visible, onFinish }: ISignInMFADialog): React.ReactElement {
	const [loading, setIsLoading] = useState(false)
	const [form] = Form.useForm<IFormValues>()

	async function callOnFinish() {
		const { code } = form.getFieldsValue()

		await onFinish(code ? code.replaceAll(' ', '') : '')
		form.resetFields()

		setIsLoading(false)
	}

	return (
		<Modal
			title="Двухфакторная авторизация"
			visible={visible}
			onCancel={() => void onFinish('')}
			footer={[
				<Button
					disabled={loading}
					onClick={() => void onFinish('')}
					key="cancel"
				>
					Отклонить
				</Button>,

				<Button
					loading={loading}
					onClick={() => void callOnFinish()}
					key="ok" type="primary"
				>
					Отправить
				</Button>
			]}
		>
			<Form form={form} layout="vertical">
				<Form.Item
					label="Введите код двухфакторной авторизации"
					name="code"
					rules={[{ required: true, message: 'Код двухфакторной авторизации обязателен!' }]}
					initialValue=""
				>
					<MaskedInput mask="111 111" disabled={loading}/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
